import type { WindowViewState } from './types';

export const WINDOW_STATE_OPEN: WindowViewState = 'open';
export const WINDOW_STATE_MINIMIZED: WindowViewState = 'minimized';
export const WINDOW_STATE_CLOSED: WindowViewState = 'closed';

export const DEFAULT_OPEN_WINDOW_PREFIXES: readonly string[] = [
    'chat-box.',
    'minimap.',
];

